var l = (e) => e === "alphanumeric" || e === "alphaonly" ? "text" : e, p = (e, r) => {
  let a = `${r}`;
  return e === "numeric" ? a = `${r}`.replace(/[^0-9]/gi, "") : e === "decimal" ? a = `${r}`.replace(/,/g, ".").replace(/[^0-9.]/gi, "").replace(/(\..*)\./g, "$1").replace(/^0+(?=\d)/, "") : e === "tel" ? a = `${r}`.replace(/[^0-9\s+]/gi, "") : e === "alphanumeric" ? a = `${r}`.replace(/[^a-z0-9\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF\s-]/gi, "") : e === "alphaonly" && (a = `${r}`.replace(/[^a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF\s-]/gi, "")), a;
};
export {
  p as cleanInput,
  l as mapInputModeToStandard
};

//# sourceMappingURL=input.helper.js.map